import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=35180067&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=35180067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35180067",
  null
  
)

export default component.exports